/* eslint-disable react/forbid-prop-types */
import { Button, Paper, Typography } from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as types from '../../redux/resource/ResourcesActionTypes';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import { commonResourceStyle, menuPageStyle } from '../../css/style';
import { productPaginationCount, optionPaginationCount, resourceFields } from '../../data/Constants';
import { depluralizeResourceName } from '../../utils/Functions';
import DisplayResources from '../crud/DisplayResources';
import LoadingBar from '../share/LoadingBar';
import { connect } from 'react-redux';
import { getPageSettings } from '../../selectors/index';
import { checkIsAuthorized } from '../../utils/AuthorizationChecks';
import get from 'lodash/get';

const styles = menuPageStyle();
const commonStyles = commonResourceStyle();

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm: null,
      categoryIdsIsCheckedMap: [],
      mutableProducts: props.filterProducts,
    };
  }

  importFunction = (file) => {
    const {
      actions, apiToken, match, history,
    } = this.props;
    var reader = new FileReader();
    const data = reader.readAsDataURL(file);
    reader.onload = function () {
      actions.uploadResource(apiToken, { excelFileData: reader.result }, 'companies', 'import', 'excel');
      // todo reload products, categories, customizations
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  exportFunction = () => {
    const {
      actions, apiToken,
    } = this.props;
    actions.downloadResource(apiToken, 'companies', 'export', 'excel');
  };

  componentDidMount = async () => {
    await this.getMenuResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken, actions } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getMenuResources(true);
    }
  }

  getMenuResources = async (forceFetch = false) => {
    const {
      loading, actions, apiToken, categories, taxes, customizations, options, pageSettings, locations,
    } = this.props;
    // Request locations because if you come from the Locations page
    // that puts a subset of all locations in the Redux store,
    // while the Menu component instead needs the full list for its display out of stock status logic
    const queryParams = `products?start=0&count=${productPaginationCount}`;
    await actions.getAllResources(apiToken, queryParams);
    actions.filterProducts(null);
    if (!locations || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) actions.getAllResources(apiToken, 'locations');

    if (!categories || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) await actions.getAllResources(apiToken, 'categories');
    if (!taxes || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) actions.getAllResources(apiToken, 'taxes');
    if (!customizations || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) actions.getAllResources(apiToken, 'customizations');
    const optionsQueryParams = `options?start=0&count=${optionPaginationCount}&view=full`;
    if (!options || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) actions.getAllResources(apiToken, optionsQueryParams);
    if (forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) {
      this.applyCategoryFilters(null, categories, actions);
    } else {
      this.applyCategoryFilters(pageSettings, categories, actions);
    }
  }

  // returns an updated product object
  updateProductLocsToStr = (locations, products) => {
    if (!locations) return products;
    if (!products) return null;
    const locNames = new Object();
    locations.map(loc => Object.assign(locNames, { [loc.id]: loc.name }));

    const mutableProducts = cloneDeep(products);
    return mutableProducts.map((product) => {
      if (!product.locations) {
        product.locations = 'All Locations';
        return product;
      }
      product.locations = product.locations.length == locations.length
        ? 'All Locations'
        : product.locations.map(loc => locNames[loc]).join('\n\r');
      return product;
    });
  }

  applyCategoryFilters = (pageSettings, categories, actions) => {
    if (!pageSettings || !pageSettings.menu || !pageSettings.menu.categoryIdsIsCheckedMap) {
      // Sets loading to false in the Redux store
      actions.filterProducts(null);
      this.initializeCategoryCheckboxesByProducts();
    } else {
      const { categoryIdsIsCheckedMap } = pageSettings.menu;
      if (categoryIdsIsCheckedMap) {
        const isCategoryFilterCheckedMapCopy = { ...categoryIdsIsCheckedMap };
        this.filterProductsByCheckedCategories(categories, isCategoryFilterCheckedMapCopy);
      }
    }
  }

  /**
   * use to initialize the categories checkboxes in componentDidMount
   */
  initializeCategoryCheckboxesByProducts = () => {
    const { categories, filteredProducts, actions } = this.props;
    if (categories && filteredProducts) {
      const categoryIdsIsCheckedMap = {};

      const categoryNames = categories.map(category => category.name);

      filteredProducts.forEach((product) => {
        if (categoryNames.includes(product.category.name)) categoryIdsIsCheckedMap[`${product.category.id}`] = true;
      });
      actions.updatePageSettings(['menu', 'categoryIdsIsCheckedMap'], categoryIdsIsCheckedMap);
    }
  }

  filterProductsByCheckedCategories = (categories, isCheckedMapCopy) => {
    const { actions } = this.props;
    const checkedCategories = [];
    categories.forEach((category, ind) => {
      if (isCheckedMapCopy[category.id] === true) checkedCategories.push(category.name);
    });
    actions.filterProducts(checkedCategories);
  }

  onCategoryCheckBoxChange = (categoryId) => {
    const { categories, actions, pageSettings: { menu: { categoryIdsIsCheckedMap } } } = this.props;

    const isCheckedMapCopy = { ...categoryIdsIsCheckedMap };
    isCheckedMapCopy[categoryId] = !categoryIdsIsCheckedMap[categoryId];
    actions.updatePageSettings(['menu', 'categoryIdsIsCheckedMap'], isCheckedMapCopy);
    this.filterProductsByCheckedCategories(categories, isCheckedMapCopy);
  }

  onClickAddResource = (resourceName) => {
    const { actions, match, history } = this.props;
    const { subResource, resourceId } = match.params;
    // TODO: subResources do not need to call following action
    actions.clearErrors();
    if (subResource) {
      history.push(`/${resourceName}/${resourceId}/${subResource}/create`);
    } else {
      history.push(`/${resourceName}/create`);
    }
  }

  onClickViewMore = async () => {
    const {
      actions,
      apiToken,
      pagination,
      loading,
    } = this.props;
    const queryParams = `products?start=${pagination.start + pagination.count}&count=${productPaginationCount}`;
    if (!loading) {
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_REQUESTED);
      await actions.getAllResources(apiToken, queryParams).then(() => actions.filterProducts(null));
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_SUCCESS);
    }
  }

  /**
   * Renders the button and converts the text to singular from plural
   * */
  renderButton = (resourceName) => {
    let resourceToDisplay = depluralizeResourceName(resourceName);
    return (
      <Button
        onClick={() => this.onClickAddResource(resourceName)}
        style={styles.button}
      >
        {`Add New ${resourceToDisplay}`}
      </Button>
    );
  }

  /**
   * Set state of displayed list according to search field text in
   * Search Component
   */
  handleSearch = (term) => {
    const {
      actions,
      apiToken,
      categories,
      pageSettings: { menu: { categoryIdsIsCheckedMap } },
    } = this.props;
    const checkedCategories = [];
    categories.forEach((category) => {
      if (categoryIdsIsCheckedMap[category.id] === true) checkedCategories.push(category.name);
    });
    actions.getAllResources(apiToken, 'products').then(() => actions.filterProducts(checkedCategories));
    this.setState({
      searchedTerm: term,
    });
  }

  /**
   * Clear search field in Search Component
   */
  handleClearSearch = () => {
    this.setState({
      searchedTerm: '',
    });
  }

  searchProducts = () => {
    const { filteredProducts } = this.props;
    const { searchedTerm } = this.state;

    const searchedProducts = searchedTerm && filteredProducts && filteredProducts.filter((product) => {
      const normalizedSearchTerm = searchedTerm.toUpperCase();
      const normalizedProductName = product.name && product.name.toUpperCase();
      const normalizedDescription = product.description && product.description.toUpperCase();
      if (normalizedProductName.includes(normalizedSearchTerm)
        || normalizedDescription && normalizedDescription.includes(normalizedSearchTerm)) {
        return product;
      }
    });
    return searchedProducts;
  };

  render() {
    const { searchedTerm } = this.state;
    const {
      actions,
      loading,
      apiToken,
      filteredProducts,
      categories,
      taxes,
      customizations,
      match,
      viewMoreLoading,
      pagination,
      locations,
      admin,
    } = this.props;
    const { resource } = match.params;

    const mutableProducts = this.updateProductLocsToStr(locations, searchedTerm ? this.searchProducts() : filteredProducts);

    // Disable for now since pagination in products is not being used
    // TODO: the pagination in products does not work well with categories filter, it needs to be improved
    // if (mutableProducts && mutableProducts.length !== 0) {
    //   mutableProducts.push({ id: 'viewMore', value: 'VIEW MORE' });
    // }

    return (
      ((loading === true || !filteredProducts || !mutableProducts || !categories || !customizations || !taxes) && viewMoreLoading === 0)
        ? (
          <LoadingBar />
        )
        : (
          <div style={commonStyles.container}>
            <div style={commonStyles.resourceHeader}>
              <div style={commonStyles.resourceName}>
                <Typography style={commonStyles.resourceName}>Menu</Typography>
              </div>
              <div style={commonStyles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <div style={styles.container}>
              <div style={styles.leftContainer}>
                <Paper style={styles.productsContainer}>
                  <div style={styles.title}>Items</div>
                  <DisplayResources
                    data={mutableProducts}
                    categories={categories}
                    actions={actions}
                    fieldNames={resourceFields.products}
                    resourceName="products"
                    buttonArray={[{ id: 1, btnTitle: 'items' }]}
                    exportFunction={this.exportFunction}
                    importFunction={this.importFunction}
                    apiToken={apiToken}
                    handleSearch={this.handleSearch}
                    handleClearSearch={this.handleClearSearch}
                    searchedTerm={searchedTerm}
                    onClickViewMore={this.onClickViewMore}
                    totalResource={pagination && pagination.totalSize}
                    viewMoreLoading={viewMoreLoading}
                  />
                </Paper>
              </div>
              <div style={styles.rightContainer}>
                <Paper style={{ height: '36%', ...styles.smallPaper }}>
                  <div style={styles.title}>Categories</div>
                  <DisplayResources
                    data={categories}
                    products={filteredProducts}
                    actions={actions}
                    fieldNames={resourceFields.categories}
                    resourceName="categories"
                    onCategoryCheckBoxChange={this.onCategoryCheckBoxChange}
                    apiToken={apiToken}
                    isSmallTable
                  />
                  {checkIsAuthorized(admin, 'menu', 'categories', 'add') && this.renderButton('categories')}
                </Paper>
                <Paper style={{ height: '36%', ...styles.smallPaper }}>
                  <div style={styles.title}>Modifier Groups</div>
                  <DisplayResources
                    data={customizations}
                    actions={actions}
                    fieldNames={resourceFields.customizations}
                    resourceName="customizations"
                    buttonArray={[{ id: 1, btnTitle: 'Modifier Options' }]}
                    apiToken={apiToken}
                    isSmallTable
                  />
                  {checkIsAuthorized(admin, 'menu', 'customizations', 'add') && this.renderButton('customizations')}
                </Paper>
                <Paper style={{ height: '24%', ...styles.smallPaper }}>
                  <div style={styles.title}>Taxes</div>
                  <DisplayResources
                    data={taxes}
                    actions={actions}
                    fieldNames={resourceFields.taxes}
                    resourceName="taxes"
                    apiToken={apiToken}
                    isSmallTable
                  />
                  {checkIsAuthorized(admin, 'menu', 'taxes', 'add') && this.renderButton('taxes')}
                </Paper>
              </div>
            </div>
          </div>
        )
    );
  }
}

Menu.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  filteredProducts: PropTypes.arrayOf(PropTypes.object),
  categories: PropTypes.arrayOf(PropTypes.object),
  customizations: PropTypes.arrayOf(PropTypes.object),
  taxes: PropTypes.arrayOf(PropTypes.object),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  pageSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

Menu.defaultProps = {
  filteredProducts: null,
  categories: null,
  customizations: null,
  taxes: null,
};

const mapStateToProps = (state, props) => ({
  pageSettings: getPageSettings(state),
});

export default withRouter(connect(mapStateToProps)(Menu));
